export const getErrorMessage = (error: unknown, fallback: string) => {
  if (error instanceof Error && error.message) return error.message
  const ax = error as {
    response?: { data?: { message?: unknown; error?: unknown } }
  }
  const d = ax?.response?.data
  if (d) {
    const raw = d.message ?? d.error
    if (Array.isArray(raw)) return raw.map(String).join(' ')
    if (typeof raw === 'string' && raw.trim()) return raw.trim()
  }
  return fallback
}
